import React from "react";
import styles from "./Page.module.scss";

const Page: React.FC = props => {
    return <div className={styles.wrapper}>{props.children}</div>;
};

export default Page;
